import '@straal/core/utils/static/initialLoading.ts'
import './style.sass'

import { CLASSES as classes } from '@straal/globals/configs/elementConsts'

import {
  RESET_PASSWORD_URLS as urls,
  STATUS_TYPES,
} from '@straal/globals/configs/forgotConsts'

import { ajaxRequest } from '@straal/kompas/staticViews/_assets/scripts/ajax'
import {
  showThrobber,
  hideThrobber,
  displayStatusMessage,
} from '@straal/assets/staticViews/scripts/interface.ts'
import { Store } from '@straal/kompas/staticViews/_assets/scripts/validation'
import { emailValidator } from '@straal/kompas/staticViews/_assets/scripts/validationRules'

// VIEW SPECIFIC FUNCTIONS

const requestResetPassword = function(payload) {
  const throbberClass = classes.THROBBER_MAIN
  const throbber = document.querySelector(`.${throbberClass}`)
  const panelClass = classes.PANEL_CONTAINER
  const panelContainer = document.querySelector(`.${panelClass}`)
  showThrobber(throbber)
  ajaxRequest(urls.REQUEST_RESET_PASSWORD, 'POST', payload)
    .then(() => {
      hideThrobber(throbber)
      displayStatusMessage({
        type: STATUS_TYPES.SENT,
        panelContainer,
        statusTypes: STATUS_TYPES,
      })
    })
    .catch(error => {
      console.error(error.responseText)
    })
}

const submitForm = function(store) {
  return function(ev) {
    ev.preventDefault()

    store.submitForm(() => {
      const payload = {
        email: store.getInputValue('email'),
      }

      requestResetPassword(payload)
    })
  }
}

window.onafterload = function() {
  const emailField = document.getElementById('email')
  const resetBtn = document.getElementById('reset-btn')

  const store = new Store({
    submitButton: resetBtn,
    fields: [
      {
        name: 'email',
        element: emailField,
        validator: emailValidator,
      },
    ],
  })

  resetBtn.addEventListener('click', submitForm(store))
}
